export default __webpack_public_path__ + "static/media/Mark-2-HUD-Targeting (Reticle RT).2a325122.jpg";